import { BindingType, InputBinding, InputMeta } from '../types';

export const checkboxConstantError = 'Enter true or false (case-insensitive).';
export const checkboxConstantDescription = 'true = checked; false = unchecked (case-insensitive)';

export const hasInvalidCheckboxConstant = (input: InputMeta, binding: Pick<InputBinding, 'type' | 'value'>): boolean =>
    input.type === 'checkbox' &&
    binding.type === BindingType.constant &&
    binding.value != null &&
    typeof binding.value !== 'boolean' &&
    binding.value !== '' &&
    (typeof binding.value !== 'string' || !/^(true|false)$/i.test(binding.value));
